/**
 * Centralized Application Configuration
 * Update these values for different environments
 */

export const APP_CONFIG = {
  // Backend API Configuration
  API: {
    // Production API is supplied by VITE_API_BASE_URL in CI/CD.
    // Keep the Azure Container App URL as the safe production fallback.
    BASE_URL:
      (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() ||
      // "https://sms-backend-atcuhgc6aqg4bdee.centralindia-01.azurewebsites.net/api",
      "https://api.trovixtech.com/api",
    // "https://localhost:7268/api",
    TIMEOUT_MS: 30000,
  },

  // Frontend/App URL Configuration
  APP: {
    BASE_URL: (import.meta.env.VITE_APP_BASE_URL as string | undefined)?.trim() || "",
  },

  // Environment
  ENV: import.meta.env.MODE || "development",
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,

  // Authentication
  AUTH: {
    TOKEN_STORAGE_KEY: "accessToken",
    REFRESH_TOKEN_STORAGE_KEY: "refreshToken",
    TOKEN_EXPIRY_KEY: "tokenExpiry",
    DEVICE_ID_KEY: "device_identifier",
  },

  // OTP Configuration
  OTP: {
    RESEND_COOLDOWN_SECONDS: 30,
    MAX_ATTEMPTS: 5,
  },

  // UI Configuration
  UI: {
    TOAST_DURATION_MS: 3000,
  },
};

/**
 * Get API configuration
 * This can be easily swapped for environment-specific configs
 */
export function getApiBaseUrl(): string {
  return APP_CONFIG.API.BASE_URL;
}

/**
 * Get API timeout
 */
export function getApiTimeout(): number {
  return APP_CONFIG.API.TIMEOUT_MS;
}

/**
 * Get the API host with any trailing "/api" suffix stripped, for endpoints that live
 * outside the REST API surface (e.g. SignalR hubs mapped at "/hubs/...").
 */
export function getApiOriginUrl(): string {
  return APP_CONFIG.API.BASE_URL.replace(/\/api\/?$/, "");
}

/**
 * Get frontend base URL for shareable links and QR codes
 */
export function getAppBaseUrl(): string {
  if (APP_CONFIG.APP.BASE_URL) {
    return APP_CONFIG.APP.BASE_URL.replace(/\/$/, "");
  }

  if (typeof window !== "undefined") {
    return window.location.origin.replace(/\/$/, "");
  }

  return "";
}
